import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, Typography, Stack, IconButton, useMediaQuery, useTheme } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SendIcon from "@mui/icons-material/Send";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ZoomDropdown from "./ZoomDropdown";
import {
  addLogoActivityToPdfBytes,
  AddSignersData,
  downloadPdfWithAnnotations,
  downloadPdfWithTextAnnotations,
  saveData,
  updateTemplatePositionsReceiver,
  uploadModifiedPdfReceiver,
} from "./utlis";
import CircularProgress from "@mui/material/CircularProgress";
import ConfirmationDialog from "./ConfirmationDialog";
import toastAlert from "./toastAlert";
import logo1 from "../assets/logo.png";

import getActivityLogUserFiles from "./getActivityLogUserFiles";
import {
  FrontendBaseUrl,
  getBaseUrlWithSubdomain,
  getUserLocation,
  post,
} from "../apis/apis";
import SendEsignModal from "./SendEsignModal";
import SendEsignModalTemplate from "./SendEsignModalTemplate";
import getActivityLogUserTempResp from "./MaintainActivityLogTempresponse";
import getActivityLogUserBulk from "./MaintainActivityLogBulk";
import DownloadIcon from "@mui/icons-material/Download";

const buildPublicFormSignedFileName = (originalFileName, userName) => {
  const base = (originalFileName || "document").replace(/\.pdf$/i, "");
  const user = (userName || "signer").trim() || "signer";
  return `${base}_${user}.pdf`;
};

const FileUpload = ({
  backRoute,
  completeddoc,
  file_id,
  annotations,
  currentSignerName,
  signers,
  file_name,
  setFileName,
  onDownloadOriginal,
  setSigners,
  isDownloading,
  user_id,
  user_email,
  uniqIdDoc,
  originalPdf,
  emailSubject,
  setEmailSubject,
  emailMessage,
  setEmailMessage,
  receiver,
  signer_currentObject,
  currentSignerEmail,
  signerLoginId,
  fileUserid,
  all_recipientsData,
  imageUrls2,
  completed,
  imageUrlsCount,
  viewDoc,
  isDownloadingC,
  handleDownloadCompleted,
  templateDoc,
  publicform,
  onCallBackTemplateFinish,
  EditingTemp,
  templateReceiver,
  publicFormReceiver,
  templateSenderSign,
  publicFormSenderSign,
  template_responses_id,
  bulk_link_response_id,
  user,
  handleCompletedTrue,
  sendEsignModalOpenTemp,
  setSendEsignModalOpenTemp,
  logo,
  primaryColorComp,
  setShowTour,
  showTour,
  scale,
  setScale,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [sendEsignModalOpen, setSendEsignModalOpen] = useState(false);
  // const [sendEsignModalOpenTemp, setSendEsignModalOpenTemp] = useState(false);

  const [MarkAsCompleted, setMarkAsCompleted] = useState(false);
  const [MarkAsCompletedTemplate, setMarkAsCompletedTemplate] = useState(false);
  const [MarkAsCompletedPublicForm, setMarkAsCompletedPublicForm] =
    useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [isSavingClose, setIsSavingClose] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const [longText, setLongText] = useState(false);
  const [incompleteFields, setIncompleteFields] = useState([]);
  const [currentIncompleteIndex, setCurrentIncompleteIndex] = useState(0);
  const [showFinishButton, setShowFinishButton] = useState(false);

  // Add this function to check required fields
  const checkRequiredFields = useCallback(() => {
    const allIncomplete = [];

    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) return;
      pageAnnotations.forEach((annot, index) => {
        if (
          parseInt(annot.signerId) === parseInt(signerLoginId) &&
          annot.isRequired
        ) {
          const isIncomplete =
            (annot.type === "signer_text" &&
              (!annot.text || annot.text.trim() === "")) ||
            ([
              "signer_initials",
              "signer_initials_text",
              "signer_chooseImgStamp",
              "signer_chooseImgDrivingL",
              "signer_chooseImgPassportPhoto",
            ].includes(annot.type) &&
              !annot.imageUrl);

          if (isIncomplete) {
            allIncomplete.push({ pageNum: parseInt(pageNum), index, annot });
          }
        }
      });
    });

    setIncompleteFields(allIncomplete);
    // console.log("allinmcom", allIncomplete);
    setShowFinishButton(allIncomplete.length === 0);
    return allIncomplete;
  }, [annotations, signerLoginId]);
  const checkRequiredFields1 = useCallback(() => {
    const allIncomplete = [];

    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) return;
      pageAnnotations.forEach((annot, index) => {
        if (parseInt(annot.signerId) === parseInt(signerLoginId)) {
          const isIncomplete =
            (annot.type === "signer_text" &&
              (!annot.text || annot.text.trim() === "")) ||
            ([
              "signer_initials",
              "signer_initials_text",
              "signer_chooseImgStamp",
              "signer_chooseImgDrivingL",
              "signer_chooseImgPassportPhoto",
            ].includes(annot.type) &&
              !annot.imageUrl);

          if (isIncomplete) {
            allIncomplete.push({ pageNum: parseInt(pageNum), index, annot });
          }
        }
      });
    });

    setIncompleteFields(allIncomplete);
    // console.log("allinmcom", allIncomplete);
    setShowFinishButton(allIncomplete.length === 0);
    return allIncomplete;
  }, [annotations, signerLoginId]);
  // In EsignReceivingEnd.js, add these helper functions
  const smoothScrollToElement = (element, options = {}) => {
    return new Promise((resolve) => {
      if (!element) {
        resolve();
        return;
      }

      element.scrollIntoView({
        behavior: "smooth",
        block: options.block || "center",
        ...options,
      });

      // Wait for scroll to complete
      setTimeout(resolve, 500);
    });
  };

  // Add this helper function to check if a field is complete
  const isFieldComplete = (annot) => {
    if (annot.type === "signer_text") {
      return annot.text && annot.text.trim() !== "";
    }
    if (
      [
        "signer_initials",
        "signer_initials_text",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
      ].includes(annot.type)
    ) {
      return !!annot.imageUrl;
    }
    return false;
  };

  // Update the scrollToNextIncomplete function
  const scrollToNextIncompletelast = useCallback(async () => {
    if (incompleteFields.length === 0) {
      setShowFinishButton(true);
      return;
    }

    // Get current field
    const field = incompleteFields[currentIncompleteIndex];

    // Set up observer to watch for changes
    const observer = new MutationObserver(() => {
      // Check if the current field is now complete
      if (isFieldComplete(annotations[field.pageNum][field.index])) {
        observer.disconnect();

        // Update incomplete fields list
        const updatedIncomplete = incompleteFields.filter(
          (f, idx) =>
            idx !== currentIncompleteIndex &&
            !isFieldComplete(annotations[f.pageNum][f.index])
        );

        setIncompleteFields(updatedIncomplete);

        // If there are more incomplete fields, move to the next one
        if (updatedIncomplete.length > 0) {
          // Keep the index within bounds
          const nextIndex =
            currentIncompleteIndex >= updatedIncomplete.length
              ? 0
              : currentIncompleteIndex;
          setCurrentIncompleteIndex(nextIndex);

          // Scroll to next incomplete field
          const nextField = updatedIncomplete[nextIndex];
          const nextElement = document.getElementById(
            `item-${nextField.annot.id}-${nextField.pageNum}`
          );
          if (nextElement) {
            smoothScrollToElement(nextElement, {
              behavior: "smooth",
              block: "center",
            });
          }
        } else {
          // All fields are complete
          setShowFinishButton(true);
        }
      }
    });

    // Find and scroll to current element
    const itemElement = document.getElementById(
      `item-${field.annot.id}-${field.pageNum}`
    );

    if (itemElement) {
      // Start observing the element
      observer.observe(itemElement, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });

      // Scroll to element
      await smoothScrollToElement(itemElement, {
        behavior: "smooth",
        block: "center",
      });

      // Add visual indicator
      itemElement.classList.add("highlight-required");
    }

    // Cleanup observer after timeout
    setTimeout(() => {
      observer.disconnect();
      if (itemElement) {
        itemElement.classList.remove("highlight-required");
      }
    }, 5000);
  }, [incompleteFields, currentIncompleteIndex, annotations]);
  const scrollToNextIncomplete = useCallback(async () => {
    if (incompleteFields.length === 0) {
      return;
    }

    // Filter out complete (pre-filled) fields - only navigate to incomplete fields
    // Maintain original order from incompleteFields array
    const incompleteOnly = incompleteFields.filter(field => !field.isComplete);

    if (incompleteOnly.length === 0) {
      return;
    }

    // Get current field
    const currentField = incompleteFields[currentIncompleteIndex];

    // Remove highlight from previous/current field when clicking "Next Required"
    if (currentField) {
      const currentElement = document.getElementById(
        `item-${currentField.annot.id}-${currentField.pageNum}`
      );
      if (currentElement) {
        currentElement.classList.remove("highlight-required", "highlight-field");
      }
    }

    // Find the next incomplete field that comes AFTER the current field in document order
    let nextField = null;
    let nextIndex = -1;

    // Start searching from the position after current field
    for (let i = currentIncompleteIndex + 1; i < incompleteFields.length; i++) {
      const field = incompleteFields[i];
      if (!field.isComplete) {
        nextField = field;
        nextIndex = i;
        break;
      }
    }

    // If no incomplete field found after current, wrap around to the beginning
    if (!nextField) {
      for (let i = 0; i < currentIncompleteIndex; i++) {
        const field = incompleteFields[i];
        if (!field.isComplete) {
          nextField = field;
          nextIndex = i;
          break;
        }
      }
    }

    // If still no field found, use the first incomplete field
    if (!nextField && incompleteOnly.length > 0) {
      nextField = incompleteOnly[0];
      nextIndex = incompleteFields.findIndex(
        field => field.pageNum === nextField.pageNum && field.index === nextField.index
      );
    }

    if (!nextField) {
      return;
    }

    // Update the current index
    if (nextIndex >= 0) {
      setCurrentIncompleteIndex(nextIndex);
    }

    // Find and scroll to next incomplete element
    const itemElement = document.getElementById(
      `item-${nextField.annot.id}-${nextField.pageNum}`
    );

    if (itemElement) {
      // Scroll to element
      await smoothScrollToElement(itemElement, {
        behavior: "smooth",
        block: "center",
      });

      // Add visual indicator
      itemElement.classList.add(
        nextField.isRequired ? "highlight-required" : "highlight-field"
      );

      // Remove highlight after timeout (auto-disappear if user doesn't click next)
      setTimeout(() => {
        if (itemElement) {
          itemElement.classList.remove("highlight-required", "highlight-field");
        }
      }, 5000);
    }
  }, [incompleteFields, currentIncompleteIndex]);
  // Add useEffect to cleanup observers when component unmounts

  // Update the button render code

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  // download dummy
  // const [isDownloading, setIsDownloading] = useState(false);

  // end
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const markdocCompleted = async (file_id) => {
    console.log("markdocCompleted");
    const postData = {
      file_id: file_id,
      // position_array: savedCanvasData
      // position_array: filteredTextItems,
    };
    // try {
    const apiData = await post("file/completeDocumentSelfSigned", postData); // Specify the endpoint you want to call
    console.log(apiData);
    if (apiData.error) {
      toastAlert("error", "Something went wrong!");
    } else {
      toastAlert("success", apiData.message);
      setLoading(false);
      // setSelfSign(false);
      setTimeout(() => {
        let hashedUrl = `${FrontendBaseUrl}home?completed=success`;
        window.location.href = `${hashedUrl}`;
        // Get the base URL that preserves any subdomain if present
        // const baseUrlWithSubdomain = getBaseUrlWithSubdomain();

        // // Create the redirect URL by appending 'home' to the base URL
        // let hashedUrl = `${baseUrlWithSubdomain}home?completed=success`;

        // Navigate to the URL
        window.location.href = hashedUrl;
      }, 1000);

      // setStatusData("Completed");
      // fetchAllFiles("Completed");
      // setActive("4");
      // fetchAllCardsDashboard();
    }
  };
  const handleConfirm = async () => {
    setLoading(true);
    let data = await saveData(file_id, annotations, true);
    console.log("data", data);
    if (data?.error) {
      toastAlert("error", "Something went wrong!");
      return;
    }
    console.log("data", data);
    console.log("Self Signer");
    let textItems = data?.formatted_data;

    // console.log("textItems");

    // console.log(annotations[1]);
    // // // Check for `signer_dropdown` type items with empty or null `options`

    const specifiedTypes = [
      "my_text",
      "my_signature",
      "my_initials",
      "date",
      "checkmark",
      "highlight",
      "stamp",
      "my_dropdown",
    ];

    // Filter items with the specified types
    const filteredTextItems = textItems.filter((item) =>
      specifiedTypes.includes(item.type)
    );

    // Filter items without the specified types
    const nonSpecifiedTextItems = textItems.filter(
      (item) => !specifiedTypes.includes(item.type)
    );
    let response_log1;

    // Now you can use `filteredTextItems` wherever you need
    console.log(filteredTextItems);
    if (filteredTextItems.length === 0) {
      // setSelfSign(false);
      // setDownloadPdfLoader(false);
      toastAlert("error", "Please place at least one field before proceeding.");
      setLoading(false);

      return;
    }
    // Group annotations by page number
    const groupedAnnotations = {};
    filteredTextItems.forEach((item) => {
      const pageNum = item.page_no;
      if (!groupedAnnotations[pageNum]) {
        groupedAnnotations[pageNum] = [];
      }
      groupedAnnotations[pageNum].push(item);
    });

    response_log1 = await getActivityLogUserFiles({
      file_id: file_id,
      email: user_email,
      event: "COMPLETED-DOCUMENT",
      description: `${file_name} completed  `,
      status: "selfsigned",
    });
    //   const user_id = user?.user_id;
    // let ActivityLogDetails= await getActivityLog1(item.file_id)
    console.log("response_log1", response_log1);
    //   setDownloadPdfLoader(false)
    // Self-sign must use the same merge engine as Download so positions match exactly.
    let editorPageWidthPx = null;
    const firstPageKey = Object.keys(groupedAnnotations || {})[0];
    if (firstPageKey) {
      const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
      if (pageEl) {
        const rect = pageEl.getBoundingClientRect();
        if (rect?.width > 0) editorPageWidthPx = rect.width;
      }
    }

    const mergedPdfBytes = await downloadPdfWithTextAnnotations(
      originalPdf,
      groupedAnnotations,
      file_name || "document.pdf",
      {
        editorPageWidthPx: editorPageWidthPx ?? undefined,
        returnBytes: true,
      }
    );

    if (!mergedPdfBytes) {
      toastAlert("error", "Failed to apply annotations to PDF.");
      setLoading(false);
      return;
    }

    let bytesToUpload = mergedPdfBytes;
    const activityLogEntries = Array.isArray(response_log1)
      ? response_log1
      : response_log1
        ? [response_log1]
        : [];
    if (activityLogEntries.length > 0) {
      try {
        bytesToUpload = await addLogoActivityToPdfBytes({
          pdfBytes: mergedPdfBytes,
          uniqId: uniqIdDoc,
          fileName: file_name || "document.pdf",
          logo,
          activityLog: activityLogEntries,
          user_id: fileUserid || user_id,
        });
      } catch (error) {
        toastAlert(
          "error",
          "Failed to append audit trail to PDF. Please try again."
        );
        setLoading(false);
        return;
      }
    }

    await uploadModifiedPdfReceiver(
      bytesToUpload,
      file_id,
      user_id,
      file_name,
      true
    );

    console.log("Completed");
    await markdocCompleted(file_id);

    setLoading(false);
    handleCloseDialog();
  };

  const handleTemplateSenderComplete = async () => {
    setLoading(true);
    try {
      const forYouTypes = [
        "my_text",
        "my_signature",
        "my_initials",
        "date",
        "checkmark",
        "highlight",
        "stamp",
        "my_dropdown",
      ];

      const allAnnotations = Object.entries(annotations || {}).reduce(
        (acc, [pageNum, pageAnnotations]) => {
          if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) {
            return acc;
          }
          return acc.concat(
            pageAnnotations.map((annot) => ({
              ...annot,
              page_no: annot.page_no || parseInt(pageNum, 10),
            }))
          );
        },
        []
      );

      const filteredTextItems = allAnnotations.filter((item) =>
        forYouTypes.includes(item.type)
      );

      if (filteredTextItems.length === 0) {
        toastAlert(
          "error",
          "Please place at least one field for yourself before proceeding."
        );
        setLoading(false);
        return;
      }

      const senderEmail = user_email || user?.email || "";
      // template_log stores template_responses_id (same as invitee sign flow)
      const responseLogId = template_responses_id || file_id;
      let response_log1 = null;

      // Record sender signed + completed in audit trail
      const signedLog = await getActivityLogUserTempResp({
        file_id: responseLogId,
        email: senderEmail,
        event: "SIGNED-BY-SENDER",
        response_get: true,
        description: `${senderEmail} signed template ${file_name}`,
        user_shared_email: senderEmail,
      });
      if (signedLog) {
        response_log1 = signedLog;
      }

      const completedLog = await getActivityLogUserTempResp({
        file_id: responseLogId,
        email: senderEmail,
        event: "COMPLETED-DOCUMENT",
        response_get: true,
        description: `${senderEmail} completed a template ${file_name}`,
        user_shared_email: senderEmail,
      });
      if (completedLog) {
        response_log1 = completedLog;
      }

      const groupedAnnotations = {};
      filteredTextItems.forEach((item) => {
        const pageNum = item.page_no;
        if (!groupedAnnotations[pageNum]) {
          groupedAnnotations[pageNum] = [];
        }
        groupedAnnotations[pageNum].push(item);
      });

      let editorPageWidthPx = null;
      const firstPageKey = Object.keys(groupedAnnotations || {})[0];
      if (firstPageKey) {
        const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
        if (pageEl) {
          const rect = pageEl.getBoundingClientRect();
          if (rect?.width > 0) editorPageWidthPx = rect.width;
        }
      }

      const mergedPdfBytes = await downloadPdfWithTextAnnotations(
        originalPdf,
        groupedAnnotations,
        file_name || "document.pdf",
        {
          editorPageWidthPx: editorPageWidthPx ?? undefined,
          returnBytes: true,
        }
      );

      if (!mergedPdfBytes) {
        toastAlert("error", "Failed to apply annotations to PDF.");
        setLoading(false);
        return;
      }

      let bytesToUpload = mergedPdfBytes;
      const activityLogEntries = Array.isArray(response_log1)
        ? response_log1
        : response_log1
          ? [response_log1]
          : [];

      if (activityLogEntries.length > 0) {
        try {
          bytesToUpload = await addLogoActivityToPdfBytes({
            pdfBytes: mergedPdfBytes,
            uniqId: uniqIdDoc,
            fileName: file_name || "document.pdf",
            logo,
            activityLog: activityLogEntries,
            user_id: fileUserid || user_id,
          });
        } catch (error) {
          console.error("Failed to append sender audit trail", error);
          toastAlert(
            "error",
            "Failed to append audit trail to PDF. Please try again."
          );
          setLoading(false);
          return;
        }
      }

      const returningUrl = await updateTemplatePositionsReceiver(
        bytesToUpload,
        file_id,
        user_id,
        file_name
      );
      if (!returningUrl) {
        toastAlert("error", "Failed to upload merged PDF.");
        setLoading(false);
        return;
      }

      let locationData = null;
      try {
        locationData = await getUserLocation();
      } catch (e) {
        locationData = null;
      }

      const apiData = await post("template/completeSenderSign", {
        template_id: file_id,
        template_responses_id: template_responses_id,
        user_id: user_id,
        completed_doc: returningUrl,
        sender_signed_at: locationData?.date || new Date().toISOString(),
        sender_email: senderEmail,
      });

      if (apiData.error) {
        toastAlert("error", apiData.message || "Something went wrong!");
        setLoading(false);
        return;
      }

      toastAlert("success", apiData.message || "Document signed successfully");
      setTimeout(() => {
        const portalPath =
          backRoute === "home" ? "home" : backRoute === "template" ? "template" : "template";
        window.location.href = `${FrontendBaseUrl}${portalPath}`;
      }, 800);
    } catch (error) {
      console.error("template sender complete failed", error);
      toastAlert("error", "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handlePublicFormSenderComplete = async () => {
    setLoading(true);
    try {
      const forYouTypes = [
        "my_text",
        "my_signature",
        "my_initials",
        "date",
        "checkmark",
        "highlight",
        "stamp",
        "my_dropdown",
      ];

      const allAnnotations = Object.entries(annotations || {}).reduce(
        (acc, [pageNum, pageAnnotations]) => {
          if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) {
            return acc;
          }
          return acc.concat(
            pageAnnotations.map((annot) => ({
              ...annot,
              page_no: annot.page_no || parseInt(pageNum, 10),
            }))
          );
        },
        []
      );

      const filteredTextItems = allAnnotations.filter((item) =>
        forYouTypes.includes(item.type)
      );

      if (filteredTextItems.length === 0) {
        toastAlert(
          "error",
          "Please place at least one field for yourself before proceeding."
        );
        setLoading(false);
        return;
      }

      const senderEmail = user_email || user?.email || "";
      const respondentEmail = currentSignerEmail || "";
      let response_log1 = null;

      const signedLog = await getActivityLogUserBulk({
        file_id: file_id,
        email: senderEmail,
        event: "SIGNED-BY-SENDER",
        response_get: true,
        also_email: respondentEmail || undefined,
        description: `${senderEmail} signed public form ${file_name}`,
        user_shared_email: senderEmail,
      });
      if (signedLog) {
        response_log1 = signedLog;
      }

      const completedLog = await getActivityLogUserBulk({
        file_id: file_id,
        email: senderEmail,
        event: "COMPLETED-DOCUMENT",
        response_get: true,
        also_email: respondentEmail || undefined,
        description: `${senderEmail} completed a public form ${file_name}`,
        user_shared_email: senderEmail,
      });
      if (completedLog) {
        response_log1 = completedLog;
      }

      const groupedAnnotations = {};
      filteredTextItems.forEach((item) => {
        const pageNum = item.page_no;
        if (!groupedAnnotations[pageNum]) {
          groupedAnnotations[pageNum] = [];
        }
        groupedAnnotations[pageNum].push(item);
      });

      let editorPageWidthPx = null;
      const firstPageKey = Object.keys(groupedAnnotations || {})[0];
      if (firstPageKey) {
        const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
        if (pageEl) {
          const rect = pageEl.getBoundingClientRect();
          if (rect?.width > 0) editorPageWidthPx = rect.width;
        }
      }

      let authTokenForMerge = null;
      try {
        const userData = localStorage.getItem("user_data");
        if (userData) authTokenForMerge = JSON.parse(userData)?.token || null;
      } catch (_) {
        authTokenForMerge = null;
      }

      const mergedPdfBytes = await downloadPdfWithTextAnnotations(
        originalPdf,
        groupedAnnotations,
        file_name || "document.pdf",
        {
          editorPageWidthPx: editorPageWidthPx ?? undefined,
          returnBytes: true,
          authToken: authTokenForMerge || undefined,
        }
      );

      if (!mergedPdfBytes) {
        toastAlert("error", "Failed to apply annotations to PDF.");
        setLoading(false);
        return;
      }

      let bytesToUpload = mergedPdfBytes;
      const activityLogEntries = Array.isArray(response_log1)
        ? response_log1
        : response_log1
          ? [response_log1]
          : [];

      if (activityLogEntries.length > 0) {
        try {
          bytesToUpload = await addLogoActivityToPdfBytes({
            pdfBytes: mergedPdfBytes,
            uniqId: uniqIdDoc,
            fileName: file_name || "document.pdf",
            logo,
            activityLog: activityLogEntries,
            user_id: fileUserid || user_id,
          });
        } catch (error) {
          console.error("Failed to append sender audit trail", error);
          toastAlert(
            "error",
            "Failed to append audit trail to PDF. Please try again."
          );
          setLoading(false);
          return;
        }
      }

      const returningUrl = await updateTemplatePositionsReceiver(
        bytesToUpload,
        file_id,
        user_id,
        file_name
      );
      if (!returningUrl) {
        toastAlert("error", "Failed to upload merged PDF.");
        setLoading(false);
        return;
      }

      let locationData = null;
      try {
        locationData = await getUserLocation();
      } catch (e) {
        locationData = null;
      }

      const apiData = await post("bulk_links/completeSenderSign", {
        bulk_link_id: file_id,
        bulk_link_response_id: bulk_link_response_id || template_responses_id,
        user_id: user_id,
        pdf_link: returningUrl,
        sender_signed_at: locationData?.date || new Date().toISOString(),
        sender_email: senderEmail,
        location_country: locationData?.country,
        ip_address: locationData?.ip,
        region: locationData?.region,
        timezone: locationData?.timezone,
      });

      if (apiData.error) {
        toastAlert("error", apiData.message || "Something went wrong!");
        setLoading(false);
        return;
      }

      toastAlert("success", apiData.message || "Document signed successfully");
      setTimeout(() => {
        const portalPath =
          backRoute === "home"
            ? "home"
            : backRoute === "public_forms"
              ? "public_forms"
              : "public_forms";
        window.location.href = `${FrontendBaseUrl}${portalPath}`;
      }, 800);
    } catch (error) {
      console.error("public form sender complete failed", error);
      toastAlert("error", "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  function checkSignersCompletion(all_signers, current_signer) {
    // const { all_signers, current_signer } = data;
    console.log("all_signers");

    // Filter out the current signer from the list of all signers
    console.log(all_signers);
    const otherSigners = all_signers.filter(
      (signer) => signer.signer_id !== current_signer.signer_id
    );
    console.log(otherSigners);

    // Check if all remaining signers have completed_status true
    const allCompleted = otherSigners.every(
      (signer) =>
        signer.completed_status === true || signer.completed_status === "true"
    );
    console.log(allCompleted);

    // Return the result
    return allCompleted;
  }
  const saveDataSigning = async (filteredTextItems) => {
    // setsaveLoading(true);
    //console.log(savedCanvasData);
    const postData = {
      file_id: file_id,
      // position_array: savedCanvasData
      position_array: filteredTextItems,
    };
    try {
      const apiData = await post(
        "file/saveCanvasDataWithFile_IdSave",
        postData
      ); // Specify the endpoint you want to call
      //console.log('Save Data To canvas ');

      //console.log(apiData);
      if (apiData.error) {
        // setsaveLoading(false);
        // setSaveSuccess(false);
      } else {
        // setSaveSuccess(true);
        // setTimeout(() => {
        //   setSaveSuccess(false);
        //   // setsaveLoading(false);
        // }, 2000);
        // fetchDataPositions(file_id);
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
      // setsaveLoading(false)
    }
  };
  function checkSignersCompletion(all_signers, signer_currentObject) {
    // const { all_signers, current_signer } = data;
    console.log("all_signers");

    // Filter out the current signer from the list of all signers
    console.log(all_signers);
    const otherSigners = all_signers.filter(
      (signer) => signer.signer_id !== signer_currentObject.signer_id
    );
    console.log(otherSigners);

    // Check if all remaining signers have completed_status true
    const allCompleted = otherSigners.every(
      (signer) =>
        signer.completed_status === true || signer.completed_status === "true"
    );
    console.log(allCompleted);

    // Return the result
    return allCompleted;
  }
  const handleConfirm1 = async () => {
    console.log("data");
    setLoading1(true);
    // const formattedAnnotations = [];
    const formattedAnnotationsByPage = {};

    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) return;
      formattedAnnotationsByPage[pageNum] = pageAnnotations.map((annot) => ({
        id: annot.id,
        type: annot.type,
        page_no: parseInt(pageNum),
        x: annot.x,
        y: annot.y,
        width: annot.width || 150,
        height: annot.height || 30,
        text: annot.text || null,
        checked: annot.checked || false,
        imageUrl: annot.imageUrl || null,
        croppedImageData: annot.croppedImageData || null,
        format: annot.format || [],
        options: annot.options || [],
        selectedOption: annot.selectedOption || null,
        fontSize: annot.fontSize || 14,
        fontFamily: annot.fontFamily || "Helvetica",
        backgroundColor: annot.backgroundColor || null,
        borderColor: annot.borderColor || null,
        signerId: annot.signerId || null,
        signerColor: annot.signerColor || null,
        isRequired: annot.isRequired || false,
        isSignature: annot.isSignature || false,
        aspectRatio: annot.aspectRatio || null,
      }));
    });
    console.log("formaltetd an", formattedAnnotationsByPage);
    // Process each page's annotations
    // Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
    //   pageAnnotations.forEach((annot) => {
    //     // Create a clean annotation object
    //     const cleanAnnotation = {
    //       id: annot.id,
    //       type: annot.type,
    //       page_no: pageNum,
    //       x: annot.x,
    //       y: annot.y,
    //       width: annot.width || 150,
    //       height: annot.height || 30,
    //       text: annot.text || null,
    //       checked: annot.checked || false,
    //       imageUrl: annot.imageUrl || null,
    //       format: annot.format || [],
    //       fontSize: annot.fontSize || 14,
    //       fontFamily: annot.fontFamily || "Helvetica",
    //       backgroundColor: annot.backgroundColor || null,
    //       borderColor: annot.borderColor || null,
    //       signerId: annot.signerId || null,
    //       signerColor: annot.signerColor || null,
    //       isRequired: annot.isRequired || false,
    //     };

    //     formattedAnnotations.push(cleanAnnotation);
    //   });
    // });
    console.log("formattedAnnotations", formattedAnnotationsByPage);
    // let data = await saveData(file_id, annotations, true);
    // let textItems = data?.formatted_data;
    // console.log("data22", textItems);

    // //     console.log('Mark as Completed');
    let doc_completed;
    const location = await getUserLocation();
    //   setDocSignerStatusModal1(true);

    // setShowConfetti(true);
    setLoading1(true);
    // await saveData();
    let response_log1;
    let allCompletedExceptCurrent;
    // getActivityLogUserFiles
    let response_log = await getActivityLogUserFiles({
      file_id: file_id,
      email: currentSignerEmail,
      event: "SIGN-DOCUMENT",
      description: `${currentSignerEmail} signed a document ${file_name} `,
    });
    console.log("Signed By signer");

    console.log(response_log);
    if (response_log === null) {
      console.log("MAINTAIN ERROR LOG");
    } else {
      console.log("SUCCESS ");
      allCompletedExceptCurrent = checkSignersCompletion(
        signers,
        signer_currentObject
      );
      console.log("allCompletedExceptCurrent", allCompletedExceptCurrent);
      if (allCompletedExceptCurrent) {
        console.log("All accepted");
        doc_completed = true;

        if (!all_recipientsData || all_recipientsData.length === 0) {
          console.log("none");
          response_log1 = await getActivityLogUserFiles({
            file_id: file_id,
            email: currentSignerEmail,
            event: "COMPLETED-DOCUMENT",
            description: `${file_name} completed  `,
          });
        } else {
          const emails = all_recipientsData.map((recipient) => recipient.email);
          console.log("All accepted 2");

          if (emails.length === 1) {
            console.log(emails[0]);
            response_log1 = await getActivityLogUserFiles({
              file_id: file_id,
              email: currentSignerEmail,
              event: "COMPLETED-DOCUMENT",
              description: `${file_name} completed and send to recipient ${emails[0]}`,
            });
          } else {
            // Join the emails into a single string separated by commas
            const emailString = emails.join(", ");
            // Log the resulting string to the console
            console.log(emailString);
            response_log1 = await getActivityLogUserFiles({
              file_id: file_id,
              email: currentSignerEmail,
              event: "COMPLETED-DOCUMENT",
              description: `${file_name} completed and send to recipient ${emailString}`,
            });
          }
        }

        // Proceed with your action
      } else {
        console.log("Not all signers have accepted yet");
        doc_completed = false;
        // Handle the case where not all signers have accepted
      }

      console.log(annotations);
      console.log("MAINTAIN SUCCESS LOG");
      console.log(response_log1);

      const specifiedTypes = [
        "my_text",
        "my_signature",
        "my_initials",
        "date",
        "checkmark",
        "highlight",
        "stamp",
      ];

      // const filteredTextItems = formattedAnnotationsByPage.filter(
      //   (item) =>
      //     specifiedTypes.includes(item.type) ||
      //     item.signerId === signerLoginId ||
      //     item.signer_id_receive === signerLoginId
      // );
      const filteredAnnotations = Object.entries(
        formattedAnnotationsByPage
      ).reduce((acc, [pageNum, annotations]) => {
        acc[pageNum] = annotations.filter(
          (annot) =>
            annot.signerId === signerLoginId ||
            annot.type.startsWith("my_") ||
            ["date", "checkmark", "highlight", "stamp"].includes(annot.type)
        );
        return acc;
      }, {});

      // Now, filteredTextItems will contain only the items that match both conditions.
      console.log(filteredAnnotations);

      const remainingTextItems = {};
      Object.entries(formattedAnnotationsByPage).forEach(
        ([pageNum, annotations]) => {
          remainingTextItems[pageNum] = annotations.filter(
            (annot) =>
              !specifiedTypes.includes(annot.type) &&
              annot.signerId !== signerLoginId &&
              annot.signer_id_receive !== signerLoginId
          );
        }
      );
      // Now you have both arrays
      console.log("Filtered Text Items:", filteredAnnotations);
      console.log("Remaining Text Items:", remainingTextItems);

      // Merge annotations into PDF the same way as download (client-side), then upload
      const drawableTypes = [
        "my_text",
        "signer_text",
        "date",
        "signer_date",
        "my_signature",
        "my_initials",
        "signer_initials",
        "signer_initials_text",
        "checkmark",
        "signer_checkmark",
        "stamp",
        "highlight",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
        "signer_dropdown",
        "my_dropdown",
      ];
      const filteredForMerge = Object.entries(
        formattedAnnotationsByPage
      ).reduce((acc, [pageNum, pageAnnotations]) => {
        const list = pageAnnotations
          .filter((annot) => {
            if (!drawableTypes.includes(annot.type)) return false;
            if (parseInt(signerLoginId) !== parseInt(annot.signerId)) return false;
            return true;
          })
          .map((annot) => {
            return annot;
          });
        if (list.length > 0) acc[pageNum] = list;
        return acc;
      }, {});

      let editorPageWidthPx = null;
      const firstPageKey = Object.keys(filteredForMerge)[0];
      if (firstPageKey) {
        const pageEl = document.querySelector(
          `#img-${firstPageKey} .pdf-image`
        );
        if (pageEl) {
          const rect = pageEl.getBoundingClientRect();
          if (rect?.width > 0) editorPageWidthPx = rect.width;
        }
      }

      // Use the same client-side merge engine as the Download button so
      // Self-Sign output positioning is identical, then upload merged bytes.
      const mergedPdfBytes = await downloadPdfWithTextAnnotations(
        originalPdf,
        filteredForMerge,
        file_name || "document.pdf",
        {
          editorPageWidthPx: editorPageWidthPx ?? undefined,
          returnBytes: true,
        }
      );
      if (mergedPdfBytes) {
        let bytesToUpload = mergedPdfBytes;
        const activityLogEntries = Array.isArray(response_log1)
          ? response_log1
          : response_log1
            ? [response_log1]
            : [];

        // Restore audit trail append on final completion while keeping client-side merge positions.
        if (doc_completed === true && activityLogEntries.length > 0) {
          try {
            bytesToUpload = await addLogoActivityToPdfBytes({
              pdfBytes: mergedPdfBytes,
              uniqId: uniqIdDoc,
              fileName: file_name || "document.pdf",
              logo,
              activityLog: activityLogEntries,
              user_id: fileUserid || user_id,
            });
          } catch (error) {
            toastAlert(
              "error",
              "Failed to append audit trail to PDF. Please try again."
            );
            setLoading1(false);
            return;
          }
        }

        await uploadModifiedPdfReceiver(
          bytesToUpload,
          file_id,
          fileUserid,
          file_name,
          undefined
        );
      }

      await saveDataSigning(remainingTextItems);
    }
    // uncommerent
    const url_file = "dsjh";
    //     console.log('sgfsdghdfsh');
    const postData = {
      // sender_user_id:103584,

      signer_id: signerLoginId,
      file_id: file_id,
      completed_status: true,
      location_country: location?.country,
      ip_address: location?.ip,
      location_date: location?.date,
      region: location?.region,
      timezone: location?.timezone,
      url_file: url_file,
    };
    const apiData = await post("file/markDocAsCompletedBySigner", postData); // Specify the endpoint you want to call
    console.log("apixxsData");

    console.log(apiData);
    if (apiData.error) {
      setLoading1(false);

      // toastAlert('error', apiData.message);
    } else {
      // start
      console.log(annotations);
      console.log(signerLoginId);
      //     // end
      setMarkAsCompleted(false);
      completed();
      // setDocSignerStatusModal1(true);
      // setShowConfetti(true);
      setLoading1(false);
    }
  };
  const saveDatad = async () => {
    // setsaveLoading(true);
    setLoading1(true);
    let response_log1;

    let allCompletedExceptCurrent;
    let doc_completed;
    // getActivityLogUserFiles
    console.log("file_id", file_id);
    console.log("currentSignerEmail", currentSignerEmail);
    console.log("file_name", file_name);

    let response_log = await getActivityLogUserTempResp({
      file_id: file_id,
      email: currentSignerEmail,
      event: "SIGNED-BY-SIGNER",
      response_get: true,
      description: `${currentSignerEmail} completed a template ${file_name} `,
      user_shared_email: currentSignerEmail,
    });
    if (response_log === null) {
      console.log("MAINTAIN ERROR LOG");
    } else {
      console.log("MAINTAIN SUCCESS LOG");
      console.log(response_log);
      response_log1 = response_log;
    }
    console.log("response_log1", response_log1);

    // check signer all signed or not
    allCompletedExceptCurrent = checkSignersCompletion(
      signers,
      signer_currentObject
    );
    console.log("allCompletedExceptCurrent", allCompletedExceptCurrent);
    if (allCompletedExceptCurrent) {
      console.log("All accepted", currentSignerEmail);
      doc_completed = true;

      const response_logT = await getActivityLogUserTempResp({
        file_id: file_id,
        email: currentSignerEmail,
        event: "COMPLETED-DOCUMENT",
        response_get: true,
        description: `${currentSignerEmail} completed a template ${file_name} `,
        user_shared_email: currentSignerEmail,
      });
      if (response_logT === null) {
        console.log("MAINTAIN ERROR LOG");
      } else {
        console.log("MAINTAIN SUCCESS LOG");
        console.log(response_logT);
        response_log1 = response_logT;
      }
      // Proceed with your action
    } else {
      console.log("Not all signers have accepted yet");
      doc_completed = false;
      // Handle the case where not all signers have accepted
    }
    console.log("response_log1");

    console.log(response_log1);

    // // end

    const formattedAnnotationsByPage = {};

    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      if (pageNum === "_lastUpdate") return;
      // Ensure pageAnnotations is an array before mapping
      const annotationsArray = Array.isArray(pageAnnotations)
        ? pageAnnotations
        : [];
      formattedAnnotationsByPage[pageNum] = annotationsArray.map((annot) => ({
        id: annot.id,
        type: annot.type,
        page_no: parseInt(pageNum),
        x: annot.x,
        y: annot.y,
        width: annot.width || 150,
        height: annot.height || 30,
        text: annot.text || null,
        checked: annot.checked || false,
        imageUrl: annot.imageUrl || null,
        croppedImageData: annot.croppedImageData || null,
        format: annot.format || [],
        options: annot.options || [],
        selectedOption: annot.selectedOption || null,
        fontSize: annot.fontSize || 14,
        fontFamily: annot.fontFamily || "Helvetica",
        backgroundColor: annot.backgroundColor || null,
        borderColor: annot.borderColor || null,
        signerId: annot.signerId || null,
        signerColor: annot.signerColor || null,
        isRequired: annot.isRequired || false,
        isSignature: annot.isSignature || false,
        aspectRatio: annot.aspectRatio || null,
      }));
    });
    console.log("formaltetd an", formattedAnnotationsByPage);

    //console.log(textItems);
    const specifiedTypes = [
      "my_text",
      "my_signature",
      "my_initials",
      "date",
      "checkmark",
      "highlight",
      "stamp",
    ];

    const filteredAnnotations = Object.entries(
      formattedAnnotationsByPage
    ).reduce((acc, [pageNum, annotations]) => {
      acc[pageNum] = annotations.filter(
        (annot) =>
          parseInt(annot.signerId) === parseInt(signerLoginId) ||
          annot.type.startsWith("my_") ||
          ["date", "checkmark", "highlight", "stamp"].includes(annot.type)
      );
      return acc;
    }, {});

    // Now, filteredTextItems will contain only the items that match both conditions.
    console.log(filteredAnnotations);
    // Filter items that do not match the condition
    const remainingTextItems = {};
    Object.entries(formattedAnnotationsByPage).forEach(
      ([pageNum, annotations]) => {
        remainingTextItems[pageNum] = annotations.filter(
          (annot) =>
            !specifiedTypes.includes(annot.type) &&
            parseInt(annot.signerId) !== parseInt(signerLoginId) &&
            parseInt(annot.signer_id_receive) !== parseInt(signerLoginId)
        );
      }
    );

    // Now you have both arrays
    console.log("Filtered Text Items:", filteredAnnotations);
    console.log("Remaining Text Items:", remainingTextItems);
    let locationData = await getUserLocation();
    console.log("user iddd", user_id);
    // sign-template: use same frontend merge path as send-doc-to-esign
    // so download/finish output positioning matches exactly.
    const filteredForMerge = Object.entries(filteredAnnotations).reduce(
      (acc, [pageNum, pageAnnotations]) => {
        const list = (Array.isArray(pageAnnotations) ? pageAnnotations : []).map(
          (annot) => {
            return annot;
          }
        );
        if (list.length > 0) acc[pageNum] = list;
        return acc;
      },
      {}
    );

    let editorPageWidthPx = null;
    const firstPageKey = Object.keys(filteredForMerge)[0];
    if (firstPageKey) {
      const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
      if (pageEl) {
        const rect = pageEl.getBoundingClientRect();
        if (rect?.width > 0) editorPageWidthPx = rect.width;
      }
    }

    const mergedPdfBytes = await downloadPdfWithTextAnnotations(
      imageUrls2,
      filteredForMerge,
      file_name || "document.pdf",
      {
        editorPageWidthPx: editorPageWidthPx ?? undefined,
        returnBytes: true,
      }
    );

    if (!mergedPdfBytes) {
      toastAlert("error", "Failed to apply annotations to PDF.");
      setLoading1(false);
      return;
    }

    let bytesToUpload = mergedPdfBytes;
    const activityLogEntries = Array.isArray(response_log1)
      ? response_log1
      : response_log1
        ? [response_log1]
        : [];
    if (doc_completed === true && activityLogEntries.length > 0) {
      try {
        bytesToUpload = await addLogoActivityToPdfBytes({
          pdfBytes: mergedPdfBytes,
          uniqId: uniqIdDoc,
          fileName: file_name || "document.pdf",
          logo,
          activityLog: activityLogEntries,
          user_id: fileUserid || user_id,
        });
      } catch (error) {
        toastAlert(
          "error",
          "Failed to append audit trail to PDF. Please try again."
        );
        setLoading1(false);
        return;
      }
    }

    const returningUrl = await updateTemplatePositionsReceiver(
      bytesToUpload,
      file_id,
      user_id,
      file_name
    );
    if (!returningUrl) {
      toastAlert("error", "Failed to upload merged PDF.");
      setLoading1(false);
      return;
    }
    // console.log(returningUrl);
    // // uncpmment
    console.log("file_id", file_id);
    console.log("currentSignerEmail", currentSignerEmail);
    console.log("file_name", file_name);
    console.log("remainingTextItems", remainingTextItems);
    console.log("signer_currentObject", signer_currentObject);
    console.log("doc_completed", doc_completed);
    const annotationsArray1 = [];
    // Flatten the page-grouped annotations into a single array
    Object.entries(remainingTextItems).forEach(([pageNum, annotations]) => {
      const imageElem = document.querySelector(`#img-${pageNum} .pdf-image`);

      // Safety check: Skip if element not found
      if (!imageElem) {
        console.warn(`PDF image element not found for page ${pageNum}`);
        return;
      }

      const imageRect = imageElem.getBoundingClientRect();
      annotations.forEach((annot) => {
        const xPercent = (annot.x / imageRect.width) * 100;
        const yPercent = (annot.y / imageRect.height) * 100;
        // Add each annotation to the array with properly formatted properties
        annotationsArray1.push({
          // Position properties
          x: annot.x,
          y: annot.y,
          width: annot.width,
          height: annot.height,
          page_no: parseInt(pageNum),

          // Content properties
          text: annot.text,
          type: annot.type,
          imageUrl: annot.imageUrl,
          checked: annot.checked,

          // Text formatting properties
          fontSize: annot.fontSize || 14,
          fontFamily: annot.fontFamily || "Arial",
          color: annot.color || "#000000",
          format: annot.format || [],
          letterSpacing: annot.letterSpacing || 0,
          alignment: annot.alignment,
          opacity: annot.opacity || 1,

          // Style properties
          backgroundColor: annot.backgroundColor,
          borderColor: annot.borderColor,

          // Signer properties
          signerId: annot.signerId,
          signerName: annot.signerName,
          signerColor: annot.signerColor,
          isRequired: annot.isRequired,

          // Date specific properties
          dateFormat: annot.dateFormat,
          date: annot.date,

          // Dropdown specific properties
          options: annot.options,
          selectedOption: annot.selectedOption,

          // Signature/Image specific properties
          isSignature: annot.isSignature,
          aspectRatio: annot.aspectRatio,

          // Additional properties
          id: annot.id,
          scale: annot.scale,
        });
      });
    });
    console.log("annotationsArray1", annotationsArray1);
    const postData = {
      template_id: file_id,
      position_array: annotationsArray1,
      selectedSigner: signer_currentObject.template_response_signer_id,

      completed_doc: returningUrl,
      file_name: file_name,
      email_response: currentSignerEmail,
      completed_at: locationData.date,
      timezone: locationData.timezone,
      doc_completed: doc_completed,
    };
    try {
      const apiData = await post("template/saveTemplateResponse", postData); // Specify the endpoint you want to call
      console.log("Save Data To canvas ");

      console.log(apiData);
      if (apiData.error) {
        // setsaveLoading(false);
        // setSaveSuccess(false);
        toastAlert("error", apiData.message);
      } else {
        // setDocSignerStatusModal(true);
        // setSaveSuccess(true);
        setTimeout(() => {
          // setSaveSuccess(false);
          // setsaveLoading(false);
          setMarkAsCompletedTemplate(false);
          handleCompletedTrue();
        }, 2000);
        // fetchDataPositions(file_id);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
      // setsaveLoading(false)
    }
  };
  const CompleteReceivingSidePubliucForm = async () => {
    // setsaveLoading(true);
    setLoading1(true);
    let response_log1;

    let allCompletedExceptCurrent;
    let doc_completed;
    // getActivityLogUserFiles
    console.log("file_id", file_id);
    console.log("currentSignerEmail", currentSignerEmail);
    console.log("file_name", file_name);

    let response_log = await getActivityLogUserBulk({
      file_id: file_id,
      email: currentSignerEmail,
      event: "SIGNED-BY-SIGNER",
      // response_get: true,
      description: `${currentSignerEmail} completed a template ${file_name} `,
      user_shared_email: currentSignerEmail,
    });
    if (response_log === null) {
      console.log("MAINTAIN ERROR LOG");
    } else {
      console.log("MAINTAIN SUCCESS LOG");
      console.log(response_log);
      response_log1 = response_log;
    }
    console.log("response_log1", response_log1);

    // check signer all signed or not
    // allCompletedExceptCurrent = checkSignersCompletion(
    //   signers,
    //   signer_currentObject
    // );
    // console.log("allCompletedExceptCurrent", allCompletedExceptCurrent);
    // if (allCompletedExceptCurrent) {
    //   console.log("All accepted", currentSignerEmail);
    //   doc_completed = true;

    //   const response_logT = await getActivityLogUserTempResp({
    //     file_id: file_id,
    //     email: currentSignerEmail,
    //     event: "COMPLETED-DOCUMENT",
    //     response_get: true,
    //     description: `${currentSignerEmail} completed a template ${file_name} `,
    //     user_shared_email: currentSignerEmail,
    //   });
    //   if (response_logT === null) {
    //     console.log("MAINTAIN ERROR LOG");
    //   } else {
    //     console.log("MAINTAIN SUCCESS LOG");
    //     console.log(response_logT);
    //     response_log1 = response_logT;
    //   }
    //   // Proceed with your action
    // } else {
    //   console.log("Not all signers have accepted yet");
    //   doc_completed = false;
    //   // Handle the case where not all signers have accepted
    // }
    // console.log("response_log1");

    // console.log(response_log1);

    // // end

    const formattedAnnotationsByPage = {};

    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      if (pageNum === "_lastUpdate") return;
      // Ensure pageAnnotations is an array before mapping
      const annotationsArray = Array.isArray(pageAnnotations)
        ? pageAnnotations
        : [];
      formattedAnnotationsByPage[pageNum] = annotationsArray.map((annot) => ({
        id: annot.id,
        type: annot.type,
        page_no: parseInt(pageNum),
        x: annot.x,
        y: annot.y,
        width: annot.width || 150,
        height: annot.height || 30,
        text: annot.text || null,
        checked: annot.checked || false,
        imageUrl: annot.imageUrl || null,
        croppedImageData: annot.croppedImageData || null,
        format: annot.format || [],
        options: annot.options || [],
        selectedOption: annot.selectedOption || null,
        fontSize: annot.fontSize || 14,
        fontFamily: annot.fontFamily || "Helvetica",
        backgroundColor: annot.backgroundColor || null,
        borderColor: annot.borderColor || null,
        signerId: annot.signerId || null,
        signerColor: annot.signerColor || null,
        isRequired: annot.isRequired || false,
        isSignature: annot.isSignature || false,
        aspectRatio: annot.aspectRatio || null,
      }));
    });
    console.log("formaltetd an", formattedAnnotationsByPage);

    //console.log(textItems);
    const specifiedTypes = [
      "my_text",
      "my_signature",
      "my_initials",
      "date",
      "checkmark",
      "highlight",
      "stamp",
    ];

    const filteredAnnotations = Object.entries(
      formattedAnnotationsByPage
    ).reduce((acc, [pageNum, annotations]) => {
      acc[pageNum] = annotations.filter(
        (annot) =>
          annot.type.startsWith("my_") ||
          ["date", "checkmark", "highlight", "stamp"].includes(annot.type)
      );
      return acc;
    }, {});

    // Now, filteredTextItems will contain only the items that match both conditions.
    console.log(filteredAnnotations);
    // Filter items that do not match the condition
    const remainingTextItems = {};
    Object.entries(formattedAnnotationsByPage).forEach(
      ([pageNum, annotations]) => {
        remainingTextItems[pageNum] = annotations.filter(
          (annot) => !specifiedTypes.includes(annot.type)
        );
      }
    );

    // Now you have both arrays
    console.log("formattedAnnotationsByPage", formattedAnnotationsByPage);
    console.log("Remaining Text Items:", remainingTextItems);
    let locationData = await getUserLocation();
    console.log("user iddd", user_id);
    const signedFileName = buildPublicFormSignedFileName(
      file_name,
      currentSignerName
    );
    // public-form/esign: use same frontend merge behavior as send-doc-to-esign.
    const filteredForMerge = Object.entries(formattedAnnotationsByPage).reduce(
      (acc, [pageNum, pageAnnotations]) => {
        const list = (Array.isArray(pageAnnotations) ? pageAnnotations : []).map(
          (annot) => {
            return annot;
          }
        );
        if (list.length > 0) acc[pageNum] = list;
        return acc;
      },
      {}
    );

    let editorPageWidthPx = null;
    const firstPageKey = Object.keys(filteredForMerge)[0];
    if (firstPageKey) {
      const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
      if (pageEl) {
        const rect = pageEl.getBoundingClientRect();
        if (rect?.width > 0) editorPageWidthPx = rect.width;
      }
    }

    const mergedPdfBytes = await downloadPdfWithTextAnnotations(
      imageUrls2,
      filteredForMerge,
      signedFileName,
      {
        editorPageWidthPx: editorPageWidthPx ?? undefined,
        returnBytes: true,
        disableMobileTextScale: true,
      }
    );
    if (!mergedPdfBytes) {
      toastAlert("error", "Failed to apply annotations to PDF.");
      setLoading1(false);
      return;
    }

    let bytesToUpload = mergedPdfBytes;
    const activityLogEntries = Array.isArray(response_log1)
      ? response_log1
      : response_log1
        ? [response_log1]
        : [];
    if (activityLogEntries.length > 0) {
      try {
        bytesToUpload = await addLogoActivityToPdfBytes({
          pdfBytes: mergedPdfBytes,
          uniqId: uniqIdDoc,
          fileName: signedFileName,
          logo,
          activityLog: activityLogEntries,
          user_id: fileUserid || user_id,
        });
      } catch (error) {
        toastAlert(
          "error",
          "Failed to append audit trail to PDF. Please try again."
        );
        setLoading1(false);
        return;
      }
    }

    const returningUrl = await updateTemplatePositionsReceiver(
      bytesToUpload,
      file_id,
      user_id,
      signedFileName
    );
    if (!returningUrl) {
      toastAlert("error", "Failed to upload merged PDF.");
      setLoading1(false);
      return;
    }
    console.log("returningUrl", returningUrl);
    // // uncpmment
    console.log("file_id", file_id);
    console.log("currentSignerEmail", currentSignerEmail);
    console.log("curent anme", currentSignerName);

    console.log("file_name", file_name);
    console.log("remainingTextItems", remainingTextItems);

    const location = await getUserLocation();
    const postData = {
      bulk_link_id: file_id,
      email_response: currentSignerEmail,
      name_response: currentSignerName,
      location_country: location.country,
      // ip_address: location.ip,
      // file_name: fileName,
      location_date: location.date,

      // timezone: location?.timezone,

      pdfLink: returningUrl,
    };
    try {
      const apiData = await post("bulk_links/saveBulkLinkResponse", postData); // Specify the endpoint you want to call
      console.log("Save Data To canvas ");

      console.log(apiData);
      if (apiData.error) {
        // setsaveLoading(false);
        // setSaveSuccess(false);
        toastAlert("error", apiData.message);
      } else {
        // setDocSignerStatusModal(true);
        // setSaveSuccess(true);
        setTimeout(() => {
          // setSaveSuccess(false);
          // setsaveLoading(false);
          setMarkAsCompletedPublicForm(false);
          handleCompletedTrue();
        }, 2000);
        // fetchDataPositions(file_id);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
      // setsaveLoading(false)
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await saveData(file_id, annotations);
      // toastAlert("Changes saved successfully");
    } catch (error) {
      console.log("error", error);
      // toast.error(error.message || "Failed to save changes");
    } finally {
      setIsSaving(false);
    }
  };
  const handleSaveclose = async () => {
    setIsSavingClose(true);
    try {
      await saveData(file_id, annotations);
      // naviagte
      setTimeout(() => {
        // const baseUrl = window.location.origin + window.location.pathname;
        let hashedUrl = `${FrontendBaseUrl}home`;
        window.location.href = `${hashedUrl}`;
        // window.location.href = "/home?completed=success";
      }, 1000);

      // toastAlert("Changes saved successfully");
    } catch (error) {
      console.log("error", error);
      // toast.error(error.message || "Failed to save changes");
    } finally {
      setIsSavingClose(false);
    }
  };
  useEffect(() => {
    return () => {
      const elements = document.querySelectorAll(".highlight-required");
      elements.forEach((el) => el.classList.remove("highlight-required"));
    };
  }, []);
  const checkAllFields = useCallback(() => {
    const allFields = [];

    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) return;
      pageAnnotations.forEach((annot, index) => {
        if (parseInt(annot.signerId) === parseInt(signerLoginId)) {
          // Add ALL fields that belong to the current signer
          let isComplete = false;

          // Check completion based on field type
          if (annot.type === "signer_text") {
            isComplete = annot.text && annot.text.trim() !== "";
          } else if (
            [
              "signer_initials",
              "signer_initials_text",
              "signer_chooseImgStamp",
              "signer_chooseImgDrivingL",
              "signer_chooseImgPassportPhoto",
            ].includes(annot.type)
          ) {
            isComplete = !!annot.imageUrl;
          } else if (annot.type === "signer_dropdown") {
            isComplete = !!annot.selectedOption;
          } else if (annot.type === "signer_checkmark") {
            isComplete = !!annot.checked;
          } else if (annot.type === "signer_date") {
            isComplete = annot.text && annot.text.trim() !== "";
          } else {
            // For any other signer field types, consider them complete if they have content
            isComplete =
              (annot.text && annot.text.trim() !== "") ||
              !!annot.imageUrl ||
              !!annot.selectedOption ||
              !!annot.checked;
          }

          // Checkboxes are always optional (never required) even if backend sends isRequired
          const isCheckbox = annot.type === "signer_checkmark" || annot.type === "checkmark";
          allFields.push({
            pageNum: parseInt(pageNum),
            index,
            annot,
            isRequired: isCheckbox ? false : (annot.isRequired || false),
            isComplete: isComplete,
          });
        }
      });
    });

    // Still check incomplete REQUIRED fields for the finish button
    const incompleteRequiredFields = allFields.filter(
      (field) => field.isRequired && !field.isComplete
    );

    setShowFinishButton(incompleteRequiredFields.length === 0);
    setIncompleteFields(allFields); // Use ALL fields for navigation
    return allFields;
  }, [annotations, signerLoginId]);

  // When all fields are filled, disable Next and Previous buttons
  const allFieldsFilled = incompleteFields.length > 0 && incompleteFields.every((f) => f.isComplete);
  // When Finish is enabled, disable Prev and Next so user can only Finish or Download
  const prevNextDisabled = showFinishButton;

  // Add this function alongside your existing scrollToNextIncomplete function
  const scrollToPreviousIncomplete = useCallback(async () => {
    if (incompleteFields.length === 0) {
      return;
    }

    // Filter out complete (pre-filled) fields - only navigate to incomplete fields
    // Maintain original order from incompleteFields array
    const incompleteOnly = incompleteFields.filter(field => !field.isComplete);

    if (incompleteOnly.length === 0) {
      return;
    }

    // Get current field and remove its highlight when clicking "Previous"
    const currentField = incompleteFields[currentIncompleteIndex];
    if (currentField) {
      const currentElement = document.getElementById(
        `item-${currentField.annot.id}-${currentField.pageNum}`
      );
      if (currentElement) {
        currentElement.classList.remove("highlight-required", "highlight-field");
      }
    }

    // Find the previous incomplete field that comes BEFORE the current field in document order
    let previousField = null;
    let previousIndex = -1;

    // Start searching from the position before current field
    for (let i = currentIncompleteIndex - 1; i >= 0; i--) {
      const field = incompleteFields[i];
      if (!field.isComplete) {
        previousField = field;
        previousIndex = i;
        break;
      }
    }

    // If no incomplete field found before current, wrap around to the end
    if (!previousField) {
      for (let i = incompleteFields.length - 1; i > currentIncompleteIndex; i--) {
        const field = incompleteFields[i];
        if (!field.isComplete) {
          previousField = field;
          previousIndex = i;
          break;
        }
      }
    }

    // If still no field found, use the last incomplete field
    if (!previousField && incompleteOnly.length > 0) {
      previousField = incompleteOnly[incompleteOnly.length - 1];
      previousIndex = incompleteFields.findIndex(
        field => field.pageNum === previousField.pageNum && field.index === previousField.index
      );
    }

    if (!previousField) {
      return;
    }

    // Update the current index
    if (previousIndex >= 0) {
      setCurrentIncompleteIndex(previousIndex);
    }

    // Find and scroll to the element
    const itemElement = document.getElementById(
      `item-${previousField.annot.id}-${previousField.pageNum}`
    );

    if (itemElement) {
      // Scroll to element
      await smoothScrollToElement(itemElement, {
        behavior: "smooth",
        block: "center",
      });

      // Add visual indicator
      itemElement.classList.add(
        previousField.isRequired ? "highlight-required" : "highlight-field"
      );

      // Remove highlight after timeout (auto-disappear if user doesn't click next/prev)
      setTimeout(() => {
        if (itemElement) {
          itemElement.classList.remove("highlight-required", "highlight-field");
        }
      }, 5000);
    }
  }, [incompleteFields, currentIncompleteIndex]);
  useEffect(() => {
    // checkRequiredFields();
    checkAllFields();
  }, [annotations, checkRequiredFields]);

  return (
    <Box
      className="esign-bottom-bar"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: { xs: "column", sm: "row" },
        padding: { xs: "12px", sm: "16px" },
        cursor: "default !important",
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        position: "fixed",
        bottom: 0,
        left: { xs: 0, sm: "var(--left-sidebar-width)" },
        right: { xs: 0, sm: "var(--right-sidebar-width)" },
        width: { xs: "100%", sm: "auto" },
        zIndex: 1000,
        backgroundColor: "white",
        gap: { xs: 1, sm: 0 },
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
        transform: "none !important",
        zoom: "1 !important",
        transition: "left 0.2s ease, right 0.2s ease",
      }}
    >
      {/* Sign document text on the left (only for receiver) */}
      {receiver && (
        <Typography
          sx={{
            fontSize: "12px",
            color: "rgba(0, 0, 0, 0.6)",
            ml: { xs: 1, sm: 2 },
            display: { xs: "none", sm: "block" },
          }}
        >
          sign document
        </Typography>
      )}
      {/* <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}></Box> */}
      <Stack
        direction="row"
        spacing={{ xs: 0.5, sm: 1 }}
        sx={{
          flex: 1,
          justifyContent: { xs: "flex-end", sm: "flex-end" },
          alignItems: "center",
          flexWrap: { xs: "wrap", sm: "nowrap" },
          gap: { xs: 0.5, sm: 1 },
          ml: { xs: 1, sm: 2 },
        }}
      >
        {/* Zoom Dropdown - only show for receiver */}
        {receiver && scale !== undefined && setScale && (
          <ZoomDropdown scale={scale} setScale={setScale} />
        )}
        {/* {showTour && ( */}
        {/* Show Editor Tour / question mark icon – commented out
        {templateReceiver ||
          publicFormReceiver ||
          EditingTemp === false ||
          receiver ||
          completeddoc ? null : (
          <Tooltip title="Show Editor Tour">
            <HelpOutlineIcon
              style={{
                zIndex: 10000,
                cursor: "pointer",
                backgroundColor: "transparent",
                fontWeight: 400,
                borderRadius: "50%",
                padding: 3, // reduced padding for smaller icon
                fontSize: 26, // explicitly set smaller font size
              }}
              fontSize="small" // use small variant
              onClick={() => setShowTour(true)}
            />
          </Tooltip>
        )}
        */}
        {/* )} */}
        {/* {showTour && (
  <EsignEditorTour
    onClose={() => setShowTour(false)}
    forceStart={showTour}
  />
)} */}
        {/* {!isMobile && (
          <Button
            onClick={onDownloadOriginal}
            variant="contained"
            component="span"
            disabled={isDownloading}
            size={isTablet ? "small" : "medium"}
            sx={{
              textTransform: "none",
              color: "white",
              cursor: "pointer !important",
              fontWeight: 600,
              backgroundColor: "rgb(249, 164, 77)",
              boxShadow: "none",
              position: "relative",
              fontSize: { xs: "11px", sm: "13px", md: "14px" },
              padding: { xs: "4px 8px", sm: "6px 12px", md: "8px 16px" },
              "&:hover": {
                boxShadow: "none",
                backgroundColor: "#fd942a",
                cursor: "pointer !important",
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(249, 164, 77, 0.7)",
                color: "white",
              },
            }}
          >
            {isDownloading ? (
              <>
                <CircularProgress
                  size={20}
                  sx={{
                    color: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-10px",
                    marginLeft: "-10px",
                  }}
                />
                <span style={{ opacity: 0 }}>Download Original</span>
              </>
            ) : (
              "Download Original"
            )}
          </Button>
        )} */}
        {templateSenderSign === true || publicFormSenderSign === true ? (
          <Button
            className="self-sign-btn"
            startIcon={
              loading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                <DriveFileRenameOutlineIcon />
              )
            }
            variant="contained"
            size="medium"
            disabled={loading}
            onClick={
              publicFormSenderSign === true
                ? handlePublicFormSenderComplete
                : handleTemplateSenderComplete
            }
            sx={{
              textTransform: "none",
              color: "white",
              backgroundColor: "#28c76f",
              boxShadow: "none",
              cursor: "pointer !important",
              minHeight: 42,
              py: 1.25,
              px: 2,
              "&:hover": {
                boxShadow: "none",
                backgroundColor: "#1f9d57",
                cursor: "pointer !important",
              },
              "&.Mui-disabled": {
                backgroundColor: "#28c76f",
                color: "white",
                opacity: 0.7,
              },
            }}
          >
            {loading ? "Completing..." : "Complete"}
          </Button>
        ) : templateReceiver === true ? (
          <>
            {/* Desktop buttons - hidden on mobile */}
            <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 1 }}>
              {receiver && typeof onDownloadOriginal === "function" && (
                <Box
                  onClick={!isDownloading ? onDownloadOriginal : undefined}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    backgroundColor:
                      isDownloading
                        ? "rgba(33, 179, 232, 0.7)"
                        : primaryColorComp === null || primaryColorComp === undefined
                          ? "#21b3e8"
                          : primaryColorComp,
                    color: "white",
                    fontSize: { sm: "12px", md: "14px" },
                    padding: { sm: "6px 12px", md: "6px 16px" },
                    borderRadius: "4px",
                    cursor: isDownloading ? "not-allowed" : "pointer",
                    userSelect: "none",
                    fontWeight: 500,
                    border: "none",
                    outline: "none",
                    transition: "background-color 0.15s ease",
                    pointerEvents: isDownloading ? "none" : "auto",
                    position: "relative",
                    minWidth: { sm: "110px", md: "130px" },
                  }}
                >
                  {isDownloading ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    <DownloadIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                  )}
                  <span>{isDownloading ? "Downloading..." : "Download"}</span>
                </Box>
              )}
              <Box
                onClick={prevNextDisabled ? undefined : scrollToPreviousIncomplete}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  backgroundColor: "rgb(249, 164, 77)",
                  color: "white",
                  fontSize: { sm: "12px", md: "14px" },
                  padding: { sm: "6px 12px", md: "6px 16px" },
                  borderRadius: "4px",
                  cursor: prevNextDisabled ? "not-allowed" : "pointer",
                  userSelect: "none",
                  fontWeight: 500,
                  border: "none",
                  outline: "none",
                  opacity: prevNextDisabled ? 0.6 : 1,
                  pointerEvents: prevNextDisabled ? "none" : "auto",
                  transition: "background-color 0.15s ease",
                  "&:hover": {
                    backgroundColor: "#fd942a",
                  },
                  "&:active": {
                    backgroundColor: "#e8851f",
                    transform: "scale(0.98)",
                  },
                }}
              >
                <ArrowBackIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                <span>Prev</span>
              </Box>
              <Box
                onClick={prevNextDisabled ? undefined : scrollToNextIncomplete}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  backgroundColor: "rgb(249, 164, 77)",
                  color: "white",
                  fontSize: { sm: "12px", md: "14px" },
                  padding: { sm: "6px 12px", md: "6px 16px" },
                  borderRadius: "4px",
                  cursor: prevNextDisabled ? "not-allowed" : "pointer",
                  userSelect: "none",
                  fontWeight: 500,
                  border: "none",
                  outline: "none",
                  opacity: prevNextDisabled ? 0.6 : 1,
                  pointerEvents: prevNextDisabled ? "none" : "auto",
                  transition: "background-color 0.15s ease",
                  "&:hover": {
                    backgroundColor: "#fd942a",
                  },
                  "&:active": {
                    backgroundColor: "#e8851f",
                    transform: "scale(0.98)",
                  },
                }}
              >
                <ArrowForwardIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                <span>Next</span>
              </Box>
              <Box
                onClick={showFinishButton ? () => setMarkAsCompletedTemplate(true) : undefined}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: showFinishButton ? "#28c76f" : "rgba(0, 0, 0, 0.12)",
                  color: showFinishButton ? "white" : "rgba(0, 0, 0, 0.26)",
                  fontSize: { sm: "12px", md: "14px" },
                  padding: { sm: "6px 16px", md: "8px 20px" },
                  borderRadius: "4px",
                  cursor: showFinishButton ? "pointer" : "not-allowed",
                  userSelect: "none",
                  fontWeight: 500,
                  border: "none",
                  outline: "none",
                  transition: "background-color 0.15s ease",
                  pointerEvents: showFinishButton ? "auto" : "none",
                  "&:hover": {
                    backgroundColor: showFinishButton ? "#1f9d57" : "rgba(0, 0, 0, 0.12)",
                  },
                  "&:active": {
                    backgroundColor: showFinishButton ? "#1a8a4a" : "rgba(0, 0, 0, 0.12)",
                    transform: showFinishButton ? "scale(0.98)" : "none",
                  },
                }}
              >
                <span>Finish</span>
              </Box>
            </Box>
          </>
        ) : null}
        {publicFormReceiver === true ? (
          <>
            {/* Desktop buttons - hidden on mobile */}
            <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 1 }}>
              {receiver && typeof onDownloadOriginal === "function" && (
                <Box
                  onClick={!isDownloading ? onDownloadOriginal : undefined}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    backgroundColor:
                      isDownloading
                        ? "rgba(33, 179, 232, 0.7)"
                        : primaryColorComp === null || primaryColorComp === undefined
                          ? "#21b3e8"
                          : primaryColorComp,
                    color: "white",
                    fontSize: { sm: "12px", md: "14px" },
                    padding: { sm: "6px 12px", md: "6px 16px" },
                    borderRadius: "4px",
                    cursor: isDownloading ? "not-allowed" : "pointer",
                    userSelect: "none",
                    fontWeight: 500,
                    border: "none",
                    outline: "none",
                    transition: "background-color 0.15s ease",
                    pointerEvents: isDownloading ? "none" : "auto",
                    position: "relative",
                    minWidth: { sm: "110px", md: "130px" },
                  }}
                >
                  {isDownloading ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    <DownloadIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                  )}
                  <span>{isDownloading ? "Downloading..." : "Download"}</span>
                </Box>
              )}
              <Box
                onClick={prevNextDisabled ? undefined : scrollToPreviousIncomplete}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  backgroundColor: "rgb(249, 164, 77)",
                  color: "white",
                  fontSize: { sm: "12px", md: "14px" },
                  padding: { sm: "6px 12px", md: "6px 16px" },
                  borderRadius: "4px",
                  cursor: prevNextDisabled ? "not-allowed" : "pointer",
                  userSelect: "none",
                  fontWeight: 500,
                  border: "none",
                  outline: "none",
                  opacity: prevNextDisabled ? 0.6 : 1,
                  pointerEvents: prevNextDisabled ? "none" : "auto",
                  transition: "background-color 0.15s ease",
                  "&:hover": {
                    backgroundColor: "#fd942a",
                  },
                  "&:active": {
                    backgroundColor: "#e8851f",
                    transform: "scale(0.98)",
                  },
                }}
              >
                <ArrowBackIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                <span>Prev</span>
              </Box>
              <Box
                onClick={prevNextDisabled ? undefined : scrollToNextIncomplete}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  backgroundColor: "rgb(249, 164, 77)",
                  color: "white",
                  fontSize: { sm: "12px", md: "14px" },
                  padding: { sm: "6px 12px", md: "6px 16px" },
                  borderRadius: "4px",
                  cursor: prevNextDisabled ? "not-allowed" : "pointer",
                  userSelect: "none",
                  fontWeight: 500,
                  border: "none",
                  outline: "none",
                  opacity: prevNextDisabled ? 0.6 : 1,
                  pointerEvents: prevNextDisabled ? "none" : "auto",
                  transition: "background-color 0.15s ease",
                  "&:hover": {
                    backgroundColor: "#fd942a",
                  },
                  "&:active": {
                    backgroundColor: "#e8851f",
                    transform: "scale(0.98)",
                  },
                }}
              >
                <ArrowForwardIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                <span>Next</span>
              </Box>
              <Box
                onClick={showFinishButton ? () => setMarkAsCompletedPublicForm(true) : undefined}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: showFinishButton ? "#28c76f" : "rgba(0, 0, 0, 0.12)",
                  color: showFinishButton ? "white" : "rgba(0, 0, 0, 0.26)",
                  fontSize: { sm: "12px", md: "14px" },
                  padding: { sm: "6px 16px", md: "8px 20px" },
                  borderRadius: "4px",
                  cursor: showFinishButton ? "pointer" : "not-allowed",
                  userSelect: "none",
                  fontWeight: 500,
                  border: "none",
                  outline: "none",
                  transition: "background-color 0.15s ease",
                  pointerEvents: showFinishButton ? "auto" : "none",
                  "&:hover": {
                    backgroundColor: showFinishButton ? "#1f9d57" : "rgba(0, 0, 0, 0.12)",
                  },
                  "&:active": {
                    backgroundColor: showFinishButton ? "#1a8a4a" : "rgba(0, 0, 0, 0.12)",
                    transform: showFinishButton ? "scale(0.98)" : "none",
                  },
                }}
              >
                <span>Finish</span>
              </Box>
            </Box>
          </>
        ) : null}
        {templateSenderSign === true || publicFormSenderSign === true ? null : templateDoc === true ? (
          <>
            {publicform === true ? (
              <>
                {EditingTemp === false ? (
                  <>
                    {/* <Button
                    // onClick={() => {
                    //   setSendEsignModalOpenTemp(true);
                    // }}
                    variant="contained"
                    sx={{
                      backgroundColor: "#28c76f",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#1f9d57",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Copy Url
                  </Button> */}
                  </>
                ) : (
                  <Button
                    className="send-esign-btn"
                    onClick={async () => {
                      console.log("fff");
                      await onCallBackTemplateFinish();
                    }}
                    variant="contained"
                    sx={{
                      backgroundColor: "#28c76f",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#1f9d57",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Finish
                  </Button>
                )}
              </>
            ) : (
              <>
                {EditingTemp === false ? (
                  <Button
                    onClick={() => {
                      setSendEsignModalOpenTemp(true);
                    }}
                    variant="contained"
                    sx={{
                      backgroundColor: "#28c76f",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#1f9d57",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Share
                  </Button>
                ) : (
                  <Button
                    className="send-esign-btn"
                    onClick={async () => {
                      console.log("fff");
                      await onCallBackTemplateFinish();
                    }}
                    variant="contained"
                    sx={{
                      backgroundColor: "#28c76f",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#1f9d57",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Finish
                  </Button>
                )}{" "}
              </>
            )}
          </>
        ) : (
          <>
            {templateReceiver === true || publicFormReceiver === true ? null : (
              <>
                {viewDoc ? (
                  <Button
                    onClick={handleDownloadCompleted}
                    variant="contained"
                    component="span"
                    disabled={isDownloadingC}
                    sx={{
                      textTransform: "none",
                      color: "white",
                      cursor: "pointer !important",
                      fontWeight: 600,
                      backgroundColor: "#21b3e8",
                      boxShadow: "none",
                      position: "relative", // Add this for loader positioning
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor:
                          primaryColorComp === null ||
                            primaryColorComp === undefined
                            ? "#21b3e8"
                            : primaryColorComp,
                        cursor: "pointer !important",
                      },
                      "&.Mui-disabled": {
                        backgroundColor:
                          primaryColorComp === null ||
                            primaryColorComp === undefined
                            ? "#00bcff"
                            : primaryColorComp,
                        color: "white",
                      },
                    }}
                  >
                    {isDownloadingC ? (
                      <>
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "white",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                        <span style={{ opacity: 0 }}>Download Completed</span>
                      </>
                    ) : (
                      "Download Completed"
                    )}
                  </Button>
                ) : (
                  <>
                    {receiver ? (
                      <>
                        {/* Desktop buttons - hidden on mobile */}
                        <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 1 }}>
                          {typeof onDownloadOriginal === "function" && (
                            <Box
                              onClick={!isDownloading ? onDownloadOriginal : undefined}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                backgroundColor:
                                  isDownloading
                                    ? "rgba(33, 179, 232, 0.7)"
                                    : primaryColorComp === null || primaryColorComp === undefined
                                      ? "#21b3e8"
                                      : primaryColorComp,
                                color: "white",
                                fontSize: { sm: "12px", md: "14px" },
                                padding: { sm: "6px 12px", md: "6px 16px" },
                                borderRadius: "4px",
                                cursor: isDownloading ? "not-allowed" : "pointer",
                                userSelect: "none",
                                fontWeight: 500,
                                border: "none",
                                outline: "none",
                                transition: "background-color 0.15s ease",
                                pointerEvents: isDownloading ? "none" : "auto",
                                position: "relative",
                                minWidth: { sm: "110px", md: "130px" },
                              }}
                            >
                              {isDownloading ? (
                                <CircularProgress size={18} sx={{ color: "white" }} />
                              ) : (
                                <DownloadIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                              )}
                              <span>{isDownloading ? "Downloading..." : "Download"}</span>
                            </Box>
                          )}
                          <Box
                            onClick={prevNextDisabled ? undefined : scrollToPreviousIncomplete}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              backgroundColor: "rgb(249, 164, 77)",
                              color: "white",
                              fontSize: { sm: "12px", md: "14px" },
                              padding: { sm: "6px 12px", md: "6px 16px" },
                              borderRadius: "4px",
                              cursor: prevNextDisabled ? "not-allowed" : "pointer",
                              userSelect: "none",
                              fontWeight: 500,
                              border: "none",
                              outline: "none",
                              opacity: prevNextDisabled ? 0.6 : 1,
                              pointerEvents: prevNextDisabled ? "none" : "auto",
                              transition: "background-color 0.15s ease",
                              "&:hover": {
                                backgroundColor: "#fd942a",
                              },
                              "&:active": {
                                backgroundColor: "#e8851f",
                                transform: "scale(0.98)",
                              },
                            }}
                          >
                            <ArrowBackIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                            <span>Prev</span>
                          </Box>
                          <Box
                            onClick={prevNextDisabled ? undefined : scrollToNextIncomplete}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              backgroundColor: "rgb(249, 164, 77)",
                              color: "white",
                              fontSize: { sm: "12px", md: "14px" },
                              padding: { sm: "6px 12px", md: "6px 16px" },
                              borderRadius: "4px",
                              cursor: prevNextDisabled ? "not-allowed" : "pointer",
                              userSelect: "none",
                              fontWeight: 500,
                              border: "none",
                              outline: "none",
                              opacity: prevNextDisabled ? 0.6 : 1,
                              pointerEvents: prevNextDisabled ? "none" : "auto",
                              transition: "background-color 0.15s ease",
                              "&:hover": {
                                backgroundColor: "#fd942a",
                              },
                              "&:active": {
                                backgroundColor: "#e8851f",
                                transform: "scale(0.98)",
                              },
                            }}
                          >
                            <ArrowForwardIcon sx={{ fontSize: { sm: "16px", md: "18px" } }} />
                            <span>Next</span>
                          </Box>
                          <Box
                            onClick={showFinishButton ? () => setMarkAsCompleted(true) : undefined}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: showFinishButton ? "#28c76f" : "rgba(0, 0, 0, 0.12)",
                              color: showFinishButton ? "white" : "rgba(0, 0, 0, 0.26)",
                              fontSize: { sm: "12px", md: "14px" },
                              padding: { sm: "6px 16px", md: "8px 20px" },
                              borderRadius: "4px",
                              cursor: showFinishButton ? "pointer" : "not-allowed",
                              userSelect: "none",
                              fontWeight: 500,
                              border: "none",
                              outline: "none",
                              transition: "background-color 0.15s ease",
                              pointerEvents: showFinishButton ? "auto" : "none",
                              "&:hover": {
                                backgroundColor: showFinishButton ? "#1f9d57" : "rgba(0, 0, 0, 0.12)",
                              },
                              "&:active": {
                                backgroundColor: showFinishButton ? "#1a8a4a" : "rgba(0, 0, 0, 0.12)",
                                transform: showFinishButton ? "scale(0.98)" : "none",
                              },
                            }}
                          >
                            <span>Finish</span>
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "flex-end", "& > button": { minHeight: 42, py: 1.25, px: 2 } }}>
                          <Button
                            disabled={isDownloading}
                            onClick={onDownloadOriginal}
                            variant="contained"
                            component="span"
                            className="download-btn"
                            sx={{
                              textTransform: "none",
                              color: "white",
                              fontWeight: 600,
                              backgroundColor: "#28c76f",
                              boxShadow: "none",
                              cursor: "pointer !important",
                              "&:hover": {
                                boxShadow: "none",
                                backgroundColor: "#1f9d57",
                                cursor: "pointer !important",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: "#28c76f",
                                color: "white",
                                opacity: 0.6,
                              },
                            }}
                          >
                            {isDownloading ? (
                              <>
                                <CircularProgress
                                  size={24}
                                  sx={{
                                    color: "white",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                  }}
                                />
                                <span style={{ opacity: 0 }}>Download</span>
                              </>
                            ) : (
                              "Download"
                            )}
                          </Button>
                          {/* Save button - commented out
                          <Button
                            disabled={isSaving}
                            onClick={handleSave}
                          variant="contained"
                          component="span"
                          className="save-btn"
                          sx={{
                            textTransform: "none",
                            color: "white",
                            fontWeight: 600,
                            // borderColor: "rgba(0, 0, 0, 0.23)",
                            backgroundColor:
                              primaryColorComp === null ||
                              primaryColorComp === undefined
                                ? "#21b3e8"
                                : primaryColorComp,
                            boxShadow: "none",
                            cursor: "pointer !important",

                            "&:hover": {
                              boxShadow: "none",
                              backgroundColor:
                                primaryColorComp === null ||
                                primaryColorComp === undefined
                                  ? "#00bcff"
                                  : primaryColorComp,
                              cursor: "pointer !important",
                            },
                          }}
                        >
                          {isSaving ? (
                            <>
                              <CircularProgress
                                size={24}
                                sx={{
                                  color: "white",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  marginTop: "-12px",
                                  marginLeft: "-12px",
                                }}
                              />
                              <span style={{ opacity: 0 }}>Save</span>
                            </>
                          ) : (
                            "Save"
                          )}
                        </Button>
                        */}
                        </Box>
                        <Button
                          onClick={handleSaveclose}
                          disabled={isSavingClose}
                          variant="contained"
                          component="span"
                          size="medium"
                          sx={{
                            textTransform: "none",
                            color: "white",
                            fontWeight: 600,
                            backgroundColor:
                              primaryColorComp === null ||
                                primaryColorComp === undefined
                                ? "#21b3e8"
                                : primaryColorComp,
                            boxShadow: "none",
                            cursor: "pointer !important",
                            minHeight: 42,
                            py: 1.25,
                            px: 2,
                            "&:hover": {
                              boxShadow: "none",
                              backgroundColor:
                                primaryColorComp === null ||
                                  primaryColorComp === undefined
                                  ? "#00bcff"
                                  : primaryColorComp,
                              cursor: "pointer !important",
                            },
                          }}
                        >
                          {isSavingClose ? (
                            <>
                              <CircularProgress
                                size={24}
                                sx={{
                                  color: "white",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  marginTop: "-12px",
                                  marginLeft: "-12px",
                                }}
                              />
                              <span style={{ opacity: 0 }}> Save & Close</span>
                            </>
                          ) : (
                            "Save & Close"
                          )}
                        </Button>
                        <Button
                          className="self-sign-btn"
                          startIcon={<DriveFileRenameOutlineIcon />}
                          variant="contained"
                          size="medium"
                          onClick={() => {
                            const allAnnotations = Object.entries(
                              annotations
                            ).reduce((acc, [pageNum, pageAnnotations]) => {
                              return acc.concat(pageAnnotations);
                            }, []);

                            // Define "For You" annotation types
                            const forYouTypes = [
                              "my_text",
                              "my_signature",
                              "my_initials",
                              "date",
                              "checkmark",
                              "highlight",
                              "stamp",
                            ];

                            // Check if there's at least one "For You" annotation
                            const hasForYouAnnotation = allAnnotations.some(
                              (annotation) =>
                                forYouTypes.includes(annotation.type)
                            );

                            if (!hasForYouAnnotation) {
                              toastAlert(
                                "error",
                                "Please place at least one field for yourself before proceeding."
                              );
                              return;
                            }

                            // Check if there are any annotations for other signers
                            const hasSignerAnnotations = allAnnotations.some(
                              (annotation) =>
                                !forYouTypes.includes(annotation.type)
                            );

                            // Set longText based on whether there are signer annotations
                            setLongText(hasSignerAnnotations);

                            handleOpenDialog();
                          }}
                          sx={{
                            textTransform: "none",
                            color: "white",
                            backgroundColor:
                              primaryColorComp === null ||
                                primaryColorComp === undefined
                                ? "#21b3e8"
                                : primaryColorComp,
                            boxShadow: "none",
                            cursor: "pointer !important",
                            minHeight: 42,
                            py: 1.25,
                            px: 2,
                            "&:hover": {
                              boxShadow: "none",
                              backgroundColor:
                                primaryColorComp === null ||
                                  primaryColorComp === undefined
                                  ? "#00bcff"
                                  : primaryColorComp,
                              cursor: "pointer !important",
                            },
                          }}
                        >
                          Self-Sign
                        </Button>
                        <Button
                          className="send-esign-btn"
                          startIcon={<SendIcon />}
                          variant="contained"
                          onClick={() => {
                            // First check if there are any signers
                            if (signers.length === 0) {
                              toastAlert(
                                "error",
                                "Please add signers before proceeding"
                              );
                              return;
                            }

                            // Flatten all annotations from all pages into a single array
                            const allAnnotations = Object.entries(
                              annotations
                            ).reduce((acc, [pageNum, pageAnnotations]) => {
                              return acc.concat(pageAnnotations);
                            }, []);

                            // Check if each signer has at least one field
                            const signerWithoutField = signers.find(
                              (signer) =>
                                !allAnnotations.some(
                                  (annot) =>
                                    annot.signerId === signer.signer_id ||
                                    annot.signer_id === signer.signer_id
                                )
                            );

                            if (signerWithoutField) {
                              toastAlert(
                                "error",
                                `Please add at least one field for signer: ${signerWithoutField.name ||
                                signerWithoutField.email ||
                                "Unknown"
                                }`
                              );
                              return;
                            }

                            // If all validations pass, open the modal
                            setSendEsignModalOpen(true);
                          }}
                          size="medium"
                          sx={{
                            textTransform: "none",
                            color: "white",
                            backgroundColor: "rgb(22, 94, 171)",
                            boxShadow: "none",
                            cursor: "pointer !important",
                            minHeight: 42,
                            py: 1.25,
                            px: 2,
                            "&:hover": {
                              boxShadow: "none",
                              backgroundColor: "#1974d2",
                              cursor: "pointer !important",
                            },
                          }}
                        >
                          Send E-Sign
                        </Button>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </Stack>
      <ConfirmationDialog
        open={dialogOpen}
        // onClose={handleCloseDialog}
        onClose={(event, reason) => {
          // Prevent closing if loading is true
          if (loading) return;
          handleCloseDialog();
        }}
        loading={loading}
        longTextState={longText}
        onConfirm={handleConfirm}
        title="Confirm Action"
        description="Are you sure you want to complete this document?"
        alertStatus="warning" // or 'delete' based on your use case
        // detailedDescription="Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
        // longText={`Please note that all items placed for the signers will be removed and cannot be undone.Do you wish to proceed?`}
        detailedDescription={
          longText
            ? "Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
            : null
        }
        longText={
          longText
            ? "Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
            : null
        }
      />
      <ConfirmationDialog
        open={MarkAsCompleted}
        onClose={() => {
          if (!loading1) {
            setMarkAsCompleted(false);
          }
        }}
        loading={loading1}
        // longTextState={longText}
        onConfirm={handleConfirm1}
        title="Confirm Action"
        description="Are you sure you want to complete this document?"
        alertStatus="warning" // or 'delete' based on your use case
      // detailedDescription="Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
      // longText={`Please note that all items placed for the signers will be removed and cannot be undone.Do you wish to proceed?`}
      />
      <ConfirmationDialog
        open={MarkAsCompletedTemplate}
        onClose={() => {
          if (!loading1) {
            setMarkAsCompletedTemplate(false);
          }
        }}
        loading={loading1}
        // longTextState={longText}
        onConfirm={saveDatad}
        title="Confirm Action"
        description="Are you sure you want to complete this document?"
        alertStatus="warning" // or 'delete' based on your use case
      // detailedDescription="Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
      // longText={`Please note that all items placed for the signers will be removed and cannot be undone.Do you wish to proceed?`}
      />
      <ConfirmationDialog
        open={MarkAsCompletedPublicForm}
        onClose={() => {
          if (!loading1) {
            setMarkAsCompletedPublicForm(false);
          }
        }}
        loading={loading1}
        // longTextState={longText}
        onConfirm={CompleteReceivingSidePubliucForm}
        title="Confirm Action"
        description="Are you sure you want to complete this document?"
        alertStatus="warning" // or 'delete' based on your use case
      // detailedDescription="Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
      // longText={`Please note that all items placed for the signers will be removed and cannot be undone.Do you wish to proceed?`}
      />
      {/* Add the modal */}
      <SendEsignModal
        primaryColorComp={primaryColorComp}
        uniqIdDoc={uniqIdDoc}
        imageUrls={originalPdf}
        user_id={user_id}
        annotations={annotations}
        emailSubject={emailSubject}
        setDocumnetName={(d) => {
          setFileName(d);
        }}
        setEmailSubject={setEmailSubject}
        emailMessage={emailMessage}
        setEmailMessage={setEmailMessage}
        file_id={file_id}
        open={sendEsignModalOpen}
        onClose={() => setSendEsignModalOpen(false)}
        documentName={file_name}
        signers={signers}
        onUpdateSigners={(updatedSigners) => setSigners(updatedSigners)}
      />
      <SendEsignModalTemplate
        primaryColorComp={primaryColorComp}
        setSigners={setSigners}
        uniqIdDoc={uniqIdDoc}
        imageUrls={originalPdf}
        user_id={user_id}
        annotations={annotations}
        emailSubject={emailSubject}
        setDocumnetName={(d) => {
          setFileName(d);
        }}
        setEmailSubject={setEmailSubject}
        emailMessage={emailMessage}
        setEmailMessage={setEmailMessage}
        file_id={file_id}
        open={sendEsignModalOpenTemp}
        user={user}
        onClose={() => {
          if (window.innerWidth < 760) {
            window.location.href = `${FrontendBaseUrl}template`;
          } else {
            setSendEsignModalOpenTemp(false);
          }
        }}
        documentName={file_name}
        signers={signers}
        onUpdateSigners={(updatedSigners) => setSigners(updatedSigners)}
      />

      {/* Mobile Bottom Navigation Bar */}
      {(templateReceiver === true || publicFormReceiver === true || receiver === true) && (
        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "white",
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
            padding: "10px 12px",
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1000,
            boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
            maxWidth: "100vw",
            transform: "none !important", // Prevent any zoom transformations
            zoom: "1 !important", // Prevent browser zoom
          }}
        >
          {/* Sign document text on the left for mobile */}
          {receiver && (
            <Typography
              sx={{
                fontSize: "11px",
                color: "rgba(0, 0, 0, 0.6)",
                position: "absolute",
                left: "12px",
                bottom: "8px",
                display: { xs: "none", sm: "block" },
              }}
            >
              sign document
            </Typography>
          )}
          {/* Mobile download button - hidden on mobile */}
          <Box
            onClick={prevNextDisabled ? undefined : scrollToPreviousIncomplete}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              backgroundColor: "rgb(249, 164, 77)",
              color: "white",
              fontSize: "13px",
              minWidth: "44px",
              padding: "8px 12px",
              borderRadius: "4px",
              cursor: prevNextDisabled ? "not-allowed" : "pointer",
              userSelect: "none",
              fontWeight: 500,
              flex: 1,
              maxWidth: "33%",
              border: "none",
              outline: "none",
              opacity: prevNextDisabled ? 0.6 : 1,
              pointerEvents: prevNextDisabled ? "none" : "auto",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "#fd942a",
              },
              "&:active": {
                backgroundColor: "#e8851f",
                transform: "scale(0.98)",
              },
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "18px" }} />
            <span>Prev</span>
          </Box>
          <Box
            onClick={prevNextDisabled ? undefined : scrollToNextIncomplete}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              backgroundColor: "rgb(249, 164, 77)",
              color: "white",
              fontSize: "13px",
              padding: "8px 12px",
              borderRadius: "4px",
              cursor: prevNextDisabled ? "not-allowed" : "pointer",
              userSelect: "none",
              fontWeight: 500,
              flex: 1,
              maxWidth: "33%",
              border: "none",
              outline: "none",
              opacity: prevNextDisabled ? 0.6 : 1,
              pointerEvents: prevNextDisabled ? "none" : "auto",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "#fd942a",
              },
              "&:active": {
                backgroundColor: "#e8851f",
                transform: "scale(0.98)",
              },
            }}
          >
            <ArrowForwardIcon sx={{ fontSize: "18px" }} />
            <span>Next</span>
          </Box>
          <Box
            onClick={showFinishButton ? () => {
              if (templateReceiver === true) {
                setMarkAsCompletedTemplate(true);
              } else if (publicFormReceiver === true) {
                setMarkAsCompletedPublicForm(true);
              } else if (receiver === true) {
                setMarkAsCompleted(true);
              }
            } : undefined}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: showFinishButton ? "#28c76f" : "rgba(0, 0, 0, 0.12)",
              color: showFinishButton ? "white" : "rgba(0, 0, 0, 0.26)",
              fontSize: "13px",
              padding: "8px 12px",
              borderRadius: "4px",
              cursor: showFinishButton ? "pointer" : "not-allowed",
              userSelect: "none",
              fontWeight: 500,
              flex: 1,
              maxWidth: "33%",
              border: "none",
              outline: "none",
              transition: "background-color 0.15s ease",
              pointerEvents: showFinishButton ? "auto" : "none",
              "&:hover": {
                backgroundColor: showFinishButton ? "#1f9d57" : "rgba(0, 0, 0, 0.12)",
              },
              "&:active": {
                backgroundColor: showFinishButton ? "#1a8a4a" : "rgba(0, 0, 0, 0.12)",
                transform: showFinishButton ? "scale(0.98)" : "none",
              },
            }}
          >
            <span>Finish</span>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FileUpload;
